require('./bootstrap')

import Vue from 'vue'
import {createInertiaApp, Head, Link} from '@inertiajs/inertia-vue'
import Swal from 'sweetalert2'
import Loading from 'vue-loading-overlay'
import VueNumeric from 'vue-numeric'
import {configureAxiosInterceptors} from './Mixins/Functions'
import helperMixins from './Mixins/HelperFunctions'
import HistogramSlider from 'vue-histogram-slider'
import carousel from 'vue-owl-carousel'
import dayjs from 'dayjs'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import VueLazyload from 'vue-lazyload'

configureAxiosInterceptors()

const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
const relativeTime = require('dayjs/plugin/relativeTime')
const advancedFormat = require('dayjs/plugin/advancedFormat')
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(advancedFormat)
dayjs.tz.setDefault('Europe/Jersey')
Vue.prototype.$dayjs = dayjs

window.xrprl = require('xrpl')
window.Vue = require('vue').default
window.Swal = Swal
const Toast = Swal.mixin({
	toast: true,
	position: 'top-end',
	showConfirmButton: false,
	timer: 3000
})
window.Toast = Toast
window.Vue = Vue

Vue.mixin({methods: {route}})
Vue.mixin(helperMixins)

Vue.component('inertia-link', Link)
Vue.component('page-title', Head)
Vue.component(HistogramSlider.name, HistogramSlider)
Vue.component('owl-carousel', carousel)
Vue.use(VueNumeric)
Vue.use(VueLazyload)

// Page components
Vue.component('main-layout', require('./Layouts/MainLayout.vue').default)
Vue.component('optimized-image', require('./Components/Common/OptimizedImage.vue').default)
Vue.component('loading-overlay', Loading)

if (process.env.APP_ENV === 'production') {
	Bugsnag.start({
		apiKey: '5841d3c0c1ae7b8a8f5e39497dd10077',
		plugins: [new BugsnagPluginVue()]
	})

	const bugsnagVue = Bugsnag.getPlugin('vue')
	Vue.use(bugsnagVue)
}

createInertiaApp({
	resolve: async name => (await import(`./Pages/${name}`)).default,
	setup({el, App, props, plugin}) {
		Vue.use(plugin)

		new Vue({
			render: h => h(App, props),
		}).$mount(el)
	},
}).then(r => {

})
